import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { TimelineTab } from "./TimelineTab";

interface JobTimelineSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  timeline: any[];
}

export const JobTimelineSheet = ({
  open,
  onOpenChange,
  timeline,
}: JobTimelineSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Timeline</SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          <TimelineTab timeline={timeline} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
